<template>
  <div>
    <span v-if="address.line_1">{{ address.line_1 }},</span>
    <span v-if="address.line_2">{{ address.line_2 }},</span>
    <span v-if="address.line_3">{{ address.line_3 }},</span>
    <span v-if="address.line_4">{{ address.line_4 }},</span>
    <span v-if="address.line_5">{{ address.line_5 }},</span>
    <span v-if="address.post_code">{{ address.post_code }}</span>
  </div>
</template>

<script>
export default {
  name: 'pretty-address',
  props: ['address']
};
</script>

<style scoped></style>
